var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeriod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "126px",
    height: "115px",
    viewBox: "0 0 126 115",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6FF24098-BC7D-4E33-A818-3FC8CC275962") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.-side-effects",
    transform: "translate(-406.000000, -646.000000)",
    strokeWidth: 4.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(409.000000, 649.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.53523,12.17787 C48.97563,9.20907 41.13363,-3e-05 41.13363,-3e-05 C41.13363,-3e-05 33.29163,9.20907 30.73203,12.17787 C12.89103,32.86917 3e-05,47.81937 3e-05,68.53737 C3e-05,91.21857 18.45243,109.67127 41.13363,109.67127 C63.81513,109.67127 82.26693,91.21887 82.26693,68.53737 C82.26693,47.81937 69.37653,32.86947 51.53523,12.17787 Z",
    id: "Stroke-1",
    stroke: "#222456",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.9621,
    y1: 87.88569,
    x2: 50.8587,
    y2: 87.88569,
    id: "Stroke-3",
    stroke: "#DE6532"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.91043,
    y1: 76.19592,
    x2: 40.91043,
    y2: 96.09252,
    id: "Stroke-5",
    stroke: "#DE6532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.91043,36.58452 C51.81453,36.58452 60.65403,45.01272 60.65403,55.40952 C60.65403,65.80632 51.81453,74.23452 40.91043,74.23452 C30.00663,74.23452 21.16713,65.80632 21.16713,55.40952 C21.16713,45.01272 30.00663,36.58452 40.91043,36.58452 Z",
    id: "Stroke-7",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.24218,
    y1: 71.10354,
    x2: 120.28608,
    y2: 71.10354,
    id: "Stroke-9",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.76404,
    y1: 56.58168,
    x2: 105.76404,
    y2: 85.62558,
    id: "Stroke-11",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.24218,
    y1: 98.55795,
    x2: 120.28608,
    y2: 98.55795,
    id: "Stroke-13",
    stroke: "#222456"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriod);
export default __webpack_public_path__ + "static/media/period.cb0f16ff.svg";
export { ForwardRef as ReactComponent };